module.exports = __webpack_public_path__ + "static/media/Queenrose.4ce83ade.jpeg";